/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagesortname3Inputs */

const en_ticketpagesortname3 = /** @type {(inputs: Ticketpagesortname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name A-Z`)
};

const de_ticketpagesortname3 = /** @type {(inputs: Ticketpagesortname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name A-Z`)
};

/**
* | output |
* | --- |
* | "Name A-Z" |
*
* @param {Ticketpagesortname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagesortname3 = /** @type {((inputs?: Ticketpagesortname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagesortname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagesortname3(inputs)
	return de_ticketpagesortname3(inputs)
});
export { ticketpagesortname3 as "ticketPageSortName" }